/**
 * Las variables que se pueden escribir dentro de una campaña o de una plantilla.
 *
 * ☠️ EL CATÁLOGO Y EL MOTOR SON LO MISMO, y tienen que seguir siéndolo. Si la
 * pantalla ofrece una variable que el motor no conoce, esa marca sale LITERAL
 * dentro del correo que recibe el cliente — «Hola {{ciudad}},». Ya pasa en este
 * repo con las plantillas de documento sembradas, que ofrecen `{{consultor.
 * fullName}}` y compañía sin que ningún motor las entienda.
 *
 * Por eso viven aquí, en el paquete compartido, y `aplicarVariables` recorre
 * ESTA lista. Añadir una variable es añadir una entrada y su valor: no hay forma
 * de ofrecer una que no se sustituya.
 *
 * La gramática es de UN nivel —`{{nombre}}`, no `{{cliente.nombre}}`— y es
 * distinta a propósito de la de las plantillas de documento: aquella tiene
 * veintiséis claves y necesita secciones; un boletín tiene cuatro.
 */
export const VARIABLES_DE_CAMPANA = [
    {
        clave: 'nombre',
        descripcion: 'El nombre de la persona o empresa a la que va el correo.',
        siNoHay: 'hola',
    },
    {
        clave: 'email',
        descripcion: 'Su dirección de correo.',
        siNoHay: '—',
    },
    {
        clave: 'remitente',
        descripcion: 'Quién lo manda. Sirve para firmar una plantilla que usáis los dos.',
        siNoHay: 'la dirección por la que sale',
    },
    {
        clave: 'fecha',
        descripcion: 'El día en que sale el correo.',
        siNoHay: 'la fecha de hoy',
    },
];
/**
 * Sustituye las variables de un texto.
 *
 * Recorre el catálogo, así que una variable listada arriba SIEMPRE se sustituye
 * y una que no esté se queda como está —y se ve, que es justo lo que hace que
 * alguien la corrija antes de mandar el correo a ciento cincuenta personas.
 */
export function aplicarVariables(texto, valores) {
    let salida = texto;
    for (const v of VARIABLES_DE_CAMPANA) {
        const valor = (valores[v.clave] ?? '').toString().trim();
        const re = new RegExp(`\\{\\{\\s*${v.clave}\\s*\\}\\}`, 'gi');
        salida = salida.replace(re, valor || v.siNoHay);
    }
    return salida;
}
//# sourceMappingURL=marketing-variables.js.map